import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventsComponent } from './events.component';

import { EventsListComponent } from './list/events-list.component';
import { EventsDetailComponent } from './detail/events-detail.component';
import { RegisterEventComponent } from './register/event-register.component';
import { EventsRankComponent } from './rank/events-rank.component';
import { EventsClassComponent } from './classing/events-class.component';

const routes: Routes = [
  {
    path: '', component: EventsComponent, children: [
      {
        path: 'register/:id/:eventEntryId', component: RegisterEventComponent
      },
      {
        path: 'rank/:eventId/:id', component: EventsRankComponent
      },
      {
        path: 'class/:eventId/:id', component: EventsClassComponent
      },
      {
        path: '', component: EventsListComponent
      },
      {
        path: ':id', component: EventsDetailComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventsRoutingModule { }
